import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { createDraftQbr } from '../api/createDraftQbr'
import { deleteQBRSettingsVersion } from '../QBRSlice'
import { selectQBRDocumentName } from '../selectors/selectQBRDocumentName'
import { selectQBREntryId } from '../selectors/selectQBREntryId'
import { selectQBRPartners } from '../selectors/selectQBRPartners'
import { selectQBRRtm } from '../selectors/selectQBRRtm'

listenerMiddleware.startListening({
  actionCreator: deleteQBRSettingsVersion,
  effect: (action, { getState, dispatch }) => {
    const state = getState()
    const entryId = selectQBREntryId(state)
    const partners = selectQBRPartners(state)
    const rtm = selectQBRRtm(state)
    const name = selectQBRDocumentName(state)

    dispatch(
      createDraftQbr({
        entryId,
        partners: partners.map((it) => it.PartnerID),
        rtm,
        name,
      })
    )
  },
})
